import { render, staticRenderFns } from "./Cloud.vue?vue&type=template&id=35acb4f8&scoped=true&"
import script from "./Cloud.vue?vue&type=script&lang=js&"
export * from "./Cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35acb4f8",
  null
  
)

export default component.exports